import { render, staticRenderFns } from "./PasswordVerificationForm.vue?vue&type=template&id=2e4ac7f9&scoped=true"
import script from "./PasswordVerificationForm.vue?vue&type=script&lang=js"
export * from "./PasswordVerificationForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordVerificationForm.vue?vue&type=style&index=0&id=2e4ac7f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ac7f9",
  null
  
)

export default component.exports